// import CustomButton from "../components/CustomButton";
//import { Link } from 'react-router-dom';
import HeroHeader from "../components/homepage/HeroHeader";
import FeatureCards from "../components/homepage/FeatureCards";
import CallToAction from "../components/homepage/CallToAction";

export default function Homepage() {
  return (
    <>
      {/* Page Container */}
      <div
        id="page-container"
        className="dark mx-auto flex min-h-dvh w-full min-w-[320px] flex-col bg-gray-100 dark:bg-gray-900 dark:text-gray-100"
      >
        {/* Page Content */}
        <main id="page-content" className="flex max-w-full flex-auto flex-col">
          {/* Hero Section: Image Side with Header Actions */}
          <HeroHeader />
          {/* END Hero Section: Image Side with Header Actions */}

          {/* Features Section: Vertical Cards */}
          <FeatureCards />
          {/* END Features Section: Vertical Cards */}

          {/* CTA Section: Simple */}
          <CallToAction />
          {/* END CTA Section: Simple */}

        </main>
        {/* END Page Content */}
      </div>
      {/* END Page Container */}
    </>
  );
}
